module.exports = __webpack_public_path__ + "img/support_a8.e082e73a.png";